import { Utils } from "@/plugins/utils";
import router from '@/router';
import moment from "moment";

export default {
	namespaced: true,
	state: {
		lstVeb: [],
		lstVebProduct: [],
		vebgeracom: 1,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false
	},
	getters: {
		
	},
	mutations: {
		set(state, lstVebLet){
			const arr = lstVebLet || [];
            state.lstVeb = arr.map(item => ({
                vebsubclas: item.vebsubclas,
                incnome: item.vebin1nome,
                vebcomis: Number(item.vebcomis || 0),
                vebgeracom: item.vebgeracom != null ? Number(item.vebgeracom) : 1,
                vebcliente: item.vebcliente,
                vebvend: item.vebvend
            }));
            state.vebgeracom = state.lstVeb[0]?.vebgeracom || 1;
            state.update = arr.length > 0;
		},
		initForm(state){
			state.insert = true
			state.update = false
			state.lstVeb = []
			state.vebgeracom = 1
		},
		setParamsDataTable(state, payload){
			state.lstVeb = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		remove(state, vebsubclas) {
			state.lstVeb = (state.lstVeb || []).filter(i => String(i.vebsubclas).trim() !== String(vebsubclas).trim());
		},
		setList(state, lstVeb) {
			state.lstVeb = lstVeb || [];
		},
	},
	actions: {
		initForm(store){
			store.commit("initForm")
		},
		async find(store, veb){
			store.state.loading = true;
            await this._vm.$axios.get(`/Representative/CommissionBySubclass/FindList/${veb.veavendcli}`)
            .then(response => {
                let lstVebLet = Utils.ValidateAxiosResponse(response.data);
                store.commit("set", lstVebLet);
            })
            .catch((error) => {
                store.dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
            });
            store.state.loading = false
		},
		save(store){
			if (store.state.update){
				store.dispatch("update")
				return
			}
			store.dispatch("insert")
		},
		async insert(store, payloads = []) {
            if (!payloads || payloads.length === 0) return true;

            const valid = payloads.filter(p => p && p.vebsubclas && (p.vebcliente || p.vebvend));
            if (valid.length === 0) return true;

            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true });

            const result = await this._vm.$axios.post("/Representative/CommissionBySubclass/Insert", valid)
                .then(response => {
                    Utils.ValidateAxiosResponse(response.data);
                    return true;
                })
                .catch(error => {
                    store.dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true });
                    return false;
                });

            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true });
            return result;
        },
        async update(store, payloads = []) {
            if (!payloads || payloads.length === 0) return true;

            const valid = payloads.filter(p => p && p.vebsubclas && (p.vebcliente || p.vebvend));
            if (valid.length === 0) return true;

            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true });

            const result = await this._vm.$axios.put("/Representative/CommissionBySubclass/Update", valid)
                .then(response => {
                    Utils.ValidateAxiosResponse(response.data);
                    return true;
                })
                .catch(error => {
                    store.dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true });
                    return false;
                });

            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true });
            return result;
        },
        async delete(store, payloads = []) {
            if (!payloads || payloads.length === 0) return true;

            const valid = payloads.filter(p => p && p.vebsubclas && (p.vebcliente || p.vebvend));
            if (valid.length === 0) return true;

            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, { root: true });

            const result = await this._vm.$axios.post("/Representative/CommissionBySubclass/Delete", valid)
                .then(response => {
                    Utils.ValidateAxiosResponse(response.data);
                    return true;
                })
                .catch(error => {
                    store.dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true });
                    return false;
                });

            store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true });
            return result;
        },
		async findList(store){
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios.get("/Representative/CommissionBySubclass/FindList")
			.then(response => {
				let lstVeb = Utils.ValidateAxiosResponse(response.data);
				store.commit("setList", lstVeb);
				store.state.hasNext = (lstVeb ? lstVeb.length : 0) > store.state.itemsPerPage
			}).catch(error => {
				store.commit("setList", []);
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			})
			store.state.loading = false
		},
		async search(store, { limit = 20, page = 1}){
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios.get(`/Representative/Representative/Search?search=${store.state.search}&limit=${limit}&page=${page}`)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				store.commit("setParamsDataTable", payload)
				return true
			})
			.catch((error) => {
				store.commit("setList", []);
				store.state.search = ""
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
		async printReportSalesByVendorRanking(store, { since , until, detail }){
			if (!since)
				since = moment().format("YYYY-MM-DDT00:00")
			if (!until)
				until = moment().format("YYYY-MM-DDT23:59")
				
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Imprimindo relatório", indeterminate: true }, {root: true})

			let payload = await this._vm.$axios.post("/Representative/Representative/PrintReportSalesByVendorRanking", {
				since,
				until,
				detail
			})
			.then(response => {
				let relatPath = Utils.ValidateAxiosResponse(response.data);

				if(relatPath)
					store.dispatch("print/openRelatsPath", [ relatPath ], { root: true })
				
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})

			return payload
		},
		

		
	}
}